import Svg, { Path } from 'react-native-svg'

export const ButtonArrow = ({ fill = '#F8EDDF' }) => (
	<Svg width={28} height={16} viewBox="0 0 37 16" fill="none">
		<Path
			d="M36.7071 8.44636C37.0976 8.05584 37.0976 7.42267 36.7071 7.03215L30.3431 0.668187C29.9526 0.277663 29.3195 0.277663 28.9289 0.668187C28.5384 1.05871 28.5384 1.69188 28.9289 2.0824L34.5858 7.73925L28.9289 13.3961C28.5384 13.7866 28.5384 14.4198 28.9289 14.8103C29.3195 15.2008 29.9526 15.2008 30.3431 14.8103L36.7071 8.44636ZM8.74228e-08 8.73926L36 8.73925L36 6.73925L-8.74228e-08 6.73926L8.74228e-08 8.73926Z"
			fill={fill}
		/>
	</Svg>
)
